import { Breadcrumb, Container } from "react-dsgov"
import { useNavigate } from "react-router";
import { useClear } from "../../hooks/useClear";
import classNames from "classnames";
import { buildPageTitle } from "../../config/portalMode";
import PageMetadata from "../../components/PageMetadata/PageMetadata";

const Comunidade : React.FC = () => {
    const navigate = useNavigate();
    const clear = useClear();

    return (
        <Container fluid={clear} className={classNames({"sem-margin": clear })}>
            <PageMetadata title={buildPageTitle("Comunidade")} />
            <Breadcrumb>
                {!clear && <Breadcrumb.Item home href="#" onClick={() => navigate("/")}></Breadcrumb.Item>}
                <Breadcrumb.Item>Comunidade</Breadcrumb.Item>
            </Breadcrumb>
        </Container>
    );
}

export default Comunidade;